import React from 'react';
import { SecretOptionsWrap } from '../adminChests/styles/EditSecretsOptions';

export const AddTeamOptions = () => {
  return <SecretOptionsWrap></SecretOptionsWrap>;
};
